/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { math } from '../../util/math';
import { Transition } from './mixins/_transition.mixin';
import { HoverFocus } from './mixins/_hover.mixin';
import { escapeSVG } from './_functions';
import { ClearFix } from './mixins/_clearfix.mixin'; 


export default ($) => css`
  .carousel {
    position: relative;
  }

  .carousel.pointer-event {
    touch-action: pan-y;
  }

  .carousel-inner {
    position: relative;
    width: 100%;
    overflow: hidden;
    ${new ClearFix().include($)}
  }

  .carousel-item {
    position: relative;
    display: none;
    float: left;
    width: 100%;
    margin-right: -100%;
    backface-visibility: hidden;
    ${new Transition($.carouselTransition).include($)}
  }

  .carousel-item.active,
  .carousel-item-next,
  .carousel-item-prev {
    display: block;
  }

  .carousel-item-next:not(.carousel-item-left),
  .active.carousel-item-right {
    transform: translateX(100%);
  }

  .carousel-item-prev:not(.carousel-item-right),
  .active.carousel-item-left {
    transform: translateX(-100%);
  }

  .carousel-fade {
    .carousel-item {
      opacity: 0;
      transition-property: opacity;
      transform: none;
    }

    .carousel-item.active,
    .carousel-item-next.carousel-item-left,
    .carousel-item-prev.carousel-item-right {
      z-index: 1;
      opacity: 1;
    }

    .active.carousel-item-left,
    .active.carousel-item-right {
      z-index: 0;
      opacity: 0;
      ${new Transition(`opacity 0s ${$.carouselTransitionDuration}`).include($)};
    }
  }

  .carousel-control-prev,
  .carousel-control-next {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${$.carouselControlWidth};
    padding: 0;
    color: ${$.carouselControlColor};
    text-align: center;
    background: none;
    border: 0;
    opacity: ${$.carouselControlOpacity};
    ${new Transition($.carouselControlTransition).include($)};

    ${new HoverFocus().include($, css`
      color: ${$.carouselControlColor};
      text-decoration: none;
      outline: 0;
      opacity: ${$.carouselControlHoverOpacity};
    `)}
  }

  .carousel-control-prev {
    left: 0;
    ${$.enableGradients ? `
      background-image: linear-gradient(90deg, ${rgba($.black, 0.25)}, ${rgba($.black, .001)});
    ` : ''}
  }

  .carousel-control-next {
    right: 0;
    ${$.enableGradients ? `
      background-image: linear-gradient(270deg, ${rgba($.black, 0.25)}, ${rgba($.black, .001)});
    ` : ''}
  }

  .carousel-control-prev-icon,
  .carousel-control-next-icon {
    display: inline-block;
    width: ${$.carouselControlIconWidth};
    height: ${$.carouselControlIconWidth};
    background: 50% / 100% 100% no-repeat;
  }

  .carousel-control-prev-icon {
    background-image: ${escapeSVG($.carouselControlPrevIconBg)};
  }

  .carousel-control-next-icon {
    background-image: ${escapeSVG($.carouselControlNextIconBg)};
  }

  .carousel-indicators {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 15;
    display: flex;
    justify-content: center;
    padding-left: 0;
    margin-right: ${$.carouselControlWidth};
    margin-left: ${$.carouselControlWidth};
    list-style: none;

    li {
      box-sizing: content-box;
      flex: 0 1 auto;
      width: ${$.carouselIndicatorWidth};
      height: ${$.carouselIndicatorHeight};
      margin-right: ${$.carouselIndicatorSpacer};
      margin-left: ${$.carouselIndicatorSpacer};
      text-indent: -999px;
      cursor: pointer;
      background-color: ${$.carouselIndicatorActiveBg};
      background-clip: padding-box;
      border-top: ${$.carouselIndicatorHitAreaHeight} solid transparent;
      border-bottom: ${$.carouselIndicatorHitAreaHeight} solid transparent;
      opacity: 0.5;
      transition: ${$.carouselIndicatorTransition};
    }

    .active {
      opacity: 1;
    }
  }

  .carousel-caption {
    position: absolute;
    right: ${math(`(100% - ${$.carouselCaptionWidth}) * 0.5`)};
    bottom: 20px;
    left: ${math(`(100% - ${$.carouselCaptionWidth}) * 0.5`)};
    z-index: 10;
    padding-top: 20px;
    padding-bottom: 20px;
    color: ${$.carouselCaptionColor};
    text-align: center;
  }
`;
